import { Resource } from 'i18next';
import { AemConfigurationListerListerSortProperty, MainWebShop } from './AemConfigurationTypes';

export type SupportedLanguages = 'NL' | 'EN' | 'FR' | 'DE';

export type DefaultCountryCode = 'NL' | 'BE' | 'LU' | 'FR' | 'US' | 'GB' | 'IE' | 'AU';

export enum CountryId {
  'NL' = 15, // Netherlands
  'DE' = 7, // Germany
  'BE' = 3, // Belgium
  'LU' = 14, // Luxembourg
  'FR' = 9, // France
  'US' = 20, // United States of America
  'GB' = 19, // Great Britain
  'GG' = 88, // Guernsey
  'JE' = 116, // Jersey
  'IE' = 12, // Ireland
  'AU' = 2, // Australia
  'NZ' = 17, // New Zeeland
  'BFPO' = 245, // British Forces Post Office
  'CZ' = 69, // Czech Republik
}

export enum PRODUCT_FREDHOPPER_SEARCH_PARAM_PLATFORM_OPTIONS {
  public_site = 'public_site',
  shoplanding = 'shoplanding',
}

export type DefaultRequestParams = {
  anaLang: string;
  language: string;
  mainWebshop: MainWebShop;
  market: string;
  shopId: string;
};

export type AuthenticationConfigObject = {
  anaLang: string;
  fictiveWebShop: string;
  locale: string;
  mainWebshop: string;
  market?: string;
};

export type ListerConfigurationSortObject = {
  properties: Array<AemConfigurationListerListerSortProperty>;
  defaultValue: string;
};

export type ObjectValues<T> = T[keyof T];

export interface StringTMap<T> {
  [key: string]: T;
}

export interface NumberTMap<T> {
  [key: number]: T;
}

export type StringStringMap = StringTMap<string>;

export type NumberStringMap = NumberTMap<string>;

export type StringNumberMap = StringTMap<number>;

export type NumberNumberMap = NumberTMap<number>;

export type StringBooleanMap = StringTMap<boolean>;

export type NumberBooleanMap = NumberTMap<boolean>;

export type StringStringArrayMap = StringTMap<Array<string>>;

export type StringStringStringArrayMap = StringTMap<StringTMap<Array<string>>>;

export type I18nTranslationObject = {
  language: string;
  translationResources: Resource;
};

export type CrumbProps = {
  title: string;
  url: string;
  isHome: boolean;
};

export type BreadcrumbsProps = {
  crumbs?: Array<CrumbProps>;
  isBreadcrumbBackButtonEnabled?: boolean;
};

export type CurrencyProps = {
  name: string;
  currency: string;
  homepage: string;
  flag: string;
  active: boolean;
};

export type CurrencyMenuItemProps = {
  currencies: Array<CurrencyProps>;
  isDesktop: boolean;
};

export type WithRequired<T, K extends keyof T> = T & Required<Pick<T, K>>;

export type WithPartial<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export type ExcludeFromUnion<T, U extends T> = T extends U ? never : T;
